<a [href]="twitterShareLink$ | async" class="social-link" target="_blank">
  <div class="social-link-img twitter"></div>
</a>
<a [href]="telegramShareLink$ | async" class="social-link" target="_blank">
  <div class="social-link-img telegram"></div>
</a>
